import { createContext, useContext } from 'react'

export const AL_DELETE = 'Delete'
export const AL_DISCLAIM = 'Discliam'
export const AL_CANCEL = 'Cancel'
export const AL_INFO = 'Info'
export const AL_EDIT = 'Edit'
export const AL_CREATE = 'Create'
export const AL_SEND_EMAIL = 'Send E-Mail'
export const AL_RESET_PASSWORD = 'Reset Password'
export const AL_CONTRACT = 'Contract'

export const defaultSelectData = {
    id: 0,
    type: '', // Delete, Cancel, Info, Edit, Create, Reset Pass
    header: '',
    body: '',
    reload: 0, // reload time
}

const selectedItemAlertContext = createContext(defaultSelectData)
export default selectedItemAlertContext

export const useSelectedItemAlertContext = () => {
    const [itemData, setItemData] = useContext(selectedItemAlertContext)
    return { itemData, setItemData }
}

export const itemData = (id, type, header, body) => {
    return {
        id: id,
        type: type, // Delete, Cancel
        header: header || '',
        body: body || '',
        reload: 0
    }
}

export const reload = (prev) => {
    return { ...prev, reload: prev.reload + 1 }
}